module.exports = __webpack_public_path__ + "img/foto_ozuv.dd2e92b7.png";